import { Injectable } from "@angular/core";
import { StateUseCaseGroupService } from "@app/flow/core/services/state-use-case-group.service";
import { StateUseCaseService } from "@app/flow/core/services/state-use-case.service";
import { AuthLowFlowService } from "@app/flow/core/services/auth-low-flow.service";
import { AuthService } from "./auth.service";

@Injectable({
	providedIn: "root",
})
export class UserSessionStateService {
	constructor(
		private authService: AuthService,
		private authLowFlowService: AuthLowFlowService,
		private stateUseCaseGroupService: StateUseCaseGroupService,
		private stateUseCaseService: StateUseCaseService
	) {}

	clear(): void {
		this.authService.clearUserState();
		this.authLowFlowService.clear();
		this.stateUseCaseGroupService.destroy();
		this.stateUseCaseService.destroy();

		sessionStorage.removeItem("app_search_flow_state");
		sessionStorage.removeItem("app_active_flow_id");
		localStorage.removeItem("user-data");
		localStorage.removeItem("userRoleLowFlow");
	}
}
